/**
 * agentAPI.js — thin wrapper over APICall for the AI Agent platform endpoints.
 * Mirrors the backend admin_service /agents routes (AgentController).
 */
import APICall from "./APICall";

const AgentAPI = {
  // ── Agents ──────────────────────────────────────────────
  listAgents:  ()          => APICall.getT("/agents"),
  getAgent:    (id)        => APICall.getT(`/agents/${id}`),
  createAgent: (payload)   => APICall.postT("/agents", payload),
  updateAgent: (id, p)     => APICall.postT(`/agents/${id}`, p),
  toggleAgent: (id)        => APICall.postT(`/agents/${id}/toggle`, {}),
  deleteAgent: (id)        => APICall.postT(`/agents/${id}/delete`, {}),

  // ── Tools ───────────────────────────────────────────────
  listTools:   ()          => APICall.getT("/agents/tools"),
  getTool:     (id)        => APICall.getT(`/agents/tools/${id}`),
  createTool:  (payload)   => APICall.postT("/agents/tools", payload),
  updateTool:  (id, p)     => APICall.postT(`/agents/tools/${id}`, p),
  deleteTool:  (id)        => APICall.postT(`/agents/tools/${id}/delete`, {}),

  // ── Activity + analytics (proxied from chat_service) ────
  sessions:  (agentId)     => APICall.getT(`/agents/activity/sessions${agentId ? `?agent_id=${agentId}` : ""}`),
  tasks:     (params = "") => APICall.getT(`/agents/activity/tasks${params}`),
  toolCalls: (params = "") => APICall.getT(`/agents/activity/tool-calls${params}`),
  logs:      (params = "") => APICall.getT(`/agents/activity/logs${params}`),
  analytics: (days = 30)   => APICall.getT(`/agents/activity/analytics?days=${days}`),
};

export default AgentAPI;
